import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import StorageManager from '../utils/storageManager'
import api from "../api"

const Home = () => import('@/components/views/dashboard/Home')
const Login = () => import('@/components/views/login/Login')
const MitelLogin = () => import('@/components/views/login/MitelLogin')
const LivevoxLogin = () => import('@/components/views/login/LivevoxLogin')
const Blank = () => import('@/components/views/blank')
const Soon = () => import('@/components/views/soon')
const AppMain = () => import('@/components/layout/AppMain')
const EmptyMain = () => import('@/components/layout/EmptyMain')
const CreateQuote = () => import('@/components/views/quotes/wizard/wizard')
const QuoteMain = () => import('@/components/views/quotes/main')
const Notifications = () => import('@/components/views/notifications/index')

//admin
const MainAdmin = () => import('@/components/views/admin/index')
const AdminQuotes = () => import('@/components/views/admin/quotes/index')
const AdminQuotesEdit = () => import('@/components/views/admin/quotes/edit')
const AdminNotifications = () => import('@/components/views/admin/notifications/index')
const AdminNotificationsCreate = () => import('@/components/views/admin/notifications/create')
const AdminNotificationsEdit = () => import('@/components/views/admin/notifications/edit')
const AdminRestrictions = () => import('@/components/views/admin/restrictions/index')
const AdminRestrictionsCreate = () => import('@/components/views/admin/restrictions/create')
const AdminRestrictionsEdit = () => import('@/components/views/admin/restrictions/edit')
const AdminStateLaws = () => import('@/components/views/admin/state_laws/index')
const AdminDisposition = () => import('@/components/views/admin/dispositions/index')
const AdminDispositionEdit = () => import('@/components/views/admin/dispositions/edit')
const AdminCallCodes = () => import('@/components/views/admin/callcodes/index')
const AdminCallCodesCreate = () => import('@/components/views/admin/callcodes/create')
const AdminCallCodesEdit = () => import('@/components/views/admin/callcodes/edit')
const AdminThirdPartyPartners = () => import('@/components/views/admin/thirdparty/index')
const AdminThirdPartyCreate = () => import('@/components/views/admin/thirdparty/create')
const AdminThirdPartyEdit = () => import('@/components/views/admin/thirdparty/edit')
const AdminUsers = () => import('@/components/views/admin/users/index')

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    { path: '*', redirect: '/dashboard' },
    { path: '/', redirect: '/dashboard' },
    {
      path: '/login', name: 'Login', component: Login,
      beforeEnter(to, from, next) {
        let carbuyToken = StorageManager.getJWT("CarBuyServiceJWT");
        carbuyToken ? next('/') : next();
      }
    },
    { path: '/mitellogin', name: 'Mitel Login', component: MitelLogin },
    { path: '/livevoxlogin', name: 'Livevox Login', component: LivevoxLogin },
    {
      path: '/dashboard', component: AppMain,
      children: [
        { path: '/', component: Home, name: 'Dashboard', meta: { description: 'Worklist' } },
        { path: '/notifications', component: Notifications, name: 'Notifications', meta: { description: 'Notifications' } },
        { path: '/blank', alias: '', component: Blank, name: 'Blank', meta: { description: 'Blank Description' } },
        { path: '/soon', alias: '', component: Soon, name: 'Soon', meta: { description: 'Blank Description' } },
        {
          path: '/quotes', name: 'Quotes', component: EmptyMain,
          children: [
            { path: '', component: MainAdmin, name: '', meta: { description: 'Quotes' } },
            { path: 'create', component: CreateQuote, name: 'Quote My Car' },
            { path: 'update', component: CreateQuote, name: 'Quote My Car', meta: { description: 'test' } },
            { path: 'main', component: QuoteMain, name: 'Quote List', meta: { description: 'test' } }
          ]
        },
        {
          path: '/admin', name: 'Admin', component: EmptyMain,
          children: [
            { path: '', component: MainAdmin, name: '', meta: { description: 'Quotes' } },
            { path: 'quotes', component: AdminQuotes, name: 'Quotes', meta: { description: 'Quotes' } },
            { path: 'quotes/:id', component: AdminQuotesEdit, name: 'Quotes', meta: { description: 'Edit Quotes' } },
            { path: 'notifications', alias: '', component: AdminNotifications, name: 'Notifications', meta: { description: 'Blank Description' } },
            { path: 'notifications/create', alias: '', component: AdminNotificationsCreate, name: 'Notifications', meta: { description: 'Blank Description' } },
            { path: 'notifications/edit', alias: '', component: AdminNotificationsEdit, name: 'Notifications', meta: { description: 'Blank Description' } },
            { path: 'restrictions', alias: '', component: AdminRestrictions, name: 'Restrictions', meta: { description: 'Blank Description' } },
            { path: 'restrictions/create', alias: '', component: AdminRestrictionsCreate, name: 'Restrictions', meta: { description: 'Blank Description' } },
            { path: 'restrictions/edit', alias: '', component: AdminRestrictionsEdit, name: 'Restrictions', meta: { description: 'Blank Description' } },
            { path: 'statelaws', alias: '', component: AdminStateLaws, name: 'State Laws', meta: { description: 'Blank Description' } },
            { path: 'dispositions', alias: '', component: AdminDisposition, name: 'Disposition', meta: { description: 'Blank Description' } },
            { path: 'dispositions/edit', alias: '', component: AdminDispositionEdit, name: 'Disposition', meta: { description: 'Blank Description' } },
            { path: 'callcodes', alias: '', component: AdminCallCodes, name: 'Call Codes', meta: { description: 'Blank Description' } },
            { path: 'callcodes/create', alias: '', component: AdminCallCodesCreate, name: 'Call Codes', meta: { description: 'Blank Description' } },
            { path: 'callcodes/edit', alias: '', component: AdminCallCodesEdit, name: 'Call Codes', meta: { description: 'Blank Description' } },
            { path: 'thirdparty', alias: '', component: AdminThirdPartyPartners, name: 'Third Party Partners', meta: { description: 'Blank Description' } },
            { path: 'thirdparty/create', alias: '', component: AdminThirdPartyCreate, name: 'Third Party Partners', meta: { description: 'Blank Description' } },
            { path: 'thirdparty/edit', alias: '', component: AdminThirdPartyEdit, name: 'Third Party Partners', meta: { description: 'Blank Description' } },
            { path: 'users', alias: '', component: AdminUsers, name: 'Users', meta: { description: 'Blank Description' } }
          ]
        },
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  let user = store.state.login;
  //prevent mitel login from overriding what the last navigation was
  if (to.path !== '/mitellogin' && to.path !== '/login') {
    store.commit('SET_LAST_NAVIGATION', to.fullPath);
  }
  if (!user.isLoggedIn) {
    StorageManager.removeJWT("CarBuyServiceJWT");
    if (to.path === '/login') {
      next()
    } else {
      next({ path: '/login', query: { isLoggedIn: user.isLoggedIn}});

    }
  } else {
    //prevent mitel login from overriding what the last navigation was
    if (to.path !== '/mitellogin' && to.path !== '/livevoxlogin') {
      store.commit('SET_LAST_NAVIGATION', to.fullPath);
    }
    api.tokenRenew().then((resp) => {
      StorageManager.saveJWT("CarBuyServiceJWT", resp.data.jwt);
      next();
    }).catch(() => {
      StorageManager.removeJWT("CarBuyServiceJWT");
      next({ path: '/login' });
    });
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js